interface AbsenceReasonNames {
  nameNl: string;
  nameFr: string;
  nameEn: string;
}

/** Name in the UI language; Dutch (the app's fallbackLng) when the language is unknown or its name is empty. */
export const getReasonName = (reason: AbsenceReasonNames, language: string | undefined): string => {
  const byLanguage: Record<string, string> = { nl: reason.nameNl, fr: reason.nameFr, en: reason.nameEn };
  return byLanguage[(language ?? '').slice(0, 2)] || reason.nameNl;
};
